namespace RedBullMOBILE360.CVM {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.CVM.CvmSegmentDialog')
    export class CvmSegmentDialog extends Serenity.EntityDialog<CvmSegmentRow, any> {
        protected getFormKey() { return CvmSegmentForm.formKey; }
        protected getIdProperty() { return CvmSegmentRow.idProperty; }
        protected getLocalTextPrefix() { return CvmSegmentRow.localTextPrefix; }
        protected getNameProperty() { return CvmSegmentRow.nameProperty; }
        protected getService() { return CvmSegmentService.baseUrl; }
        protected getDeletePermission() { return CvmSegmentRow.deletePermission; }
        protected getInsertPermission() { return CvmSegmentRow.insertPermission; }
        protected getUpdatePermission() { return CvmSegmentRow.updatePermission; }

        protected form = new CvmSegmentForm(this.idPrefix);
    }
}